import { useNavigate } from 'react-router-dom';

export default function Project750kApp() {
  const navigate = useNavigate();

  const handleViewData = () => {
    navigate('/ucc-data');
  };

  const handleViewDataListC = () => {
    navigate('/ucc-data-listc');
  };

  const handleDebtorLookup = () => {
    navigate('/reports/debtor-lookup');
  };

  const handleRegionalAnalysis = () => {
    navigate('/reports/regional-analysis');
  };

  const handleTopDebtors = () => {
    navigate('/reports/top-debtors');
  };

  const handleSecuredParties = () => {
    navigate('/reports/secured-parties');
  };

  const handleAmendmentTrends = () => {
    navigate('/reports/amendments');
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#F3F6F8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center'
      }}>
        {/* Card Container */}
        <div style={{
          backgroundColor: '#FFFFFF',
          border: '2px solid #0077B5',
          borderRadius: '8px',
          padding: '40px 20px',
          boxShadow: '0 2px 8px rgba(0, 119, 181, 0.15)'
        }}>
          <h1 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#2C3E50',
            marginBottom: '20px',
            fontFamily: 'Segoe UI, Arial, sans-serif'
          }}>
            PROJECT 750K
          </h1>
          
          <p style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '30px',
            lineHeight: '1.6',
            fontFamily: 'Segoe UI, Arial, sans-serif'
          }}>
            UCC Filing Data Management System
          </p>

          {/* Buttons Container */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'center'
          }}>
            {/* First Button */}
            <button
              onClick={handleViewData}
              style={{
                backgroundColor: '#0077B5',
                color: '#FFFFFF',
                border: '2px solid #0077B5',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                fontFamily: 'Segoe UI, Arial, sans-serif',
                minWidth: '200px'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#005885';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#0077B5';
              }}
              onMouseDown={(e) => {
                e.target.style.backgroundColor = '#004A70';
              }}
              onMouseUp={(e) => {
                e.target.style.backgroundColor = '#005885';
              }}
            >
              Look at UCCMstrLB4 Data
            </button>

            {/* Second Button */}
            <button
              onClick={handleViewDataListC}
              style={{
                backgroundColor: '#0077B5',
                color: '#FFFFFF',
                border: '2px solid #0077B5',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                fontFamily: 'Segoe UI, Arial, sans-serif',
                minWidth: '200px'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#005885';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#0077B5';
              }}
              onMouseDown={(e) => {
                e.target.style.backgroundColor = '#004A70';
              }}
              onMouseUp={(e) => {
                e.target.style.backgroundColor = '#005885';
              }}
            >
              Look at UCCMstrListC Data
            </button>

            {/* Analytics Reports Section */}
            <div style={{ marginTop: '30px', width: '100%' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#2C3E50',
                marginBottom: '16px',
                fontFamily: 'Segoe UI, Arial, sans-serif'
              }}>
                Analytics Reports
              </h3>

              {/* Grid for Report Buttons */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '12px',
                marginBottom: '12px'
              }}>
                {/* Row 1 */}
                <button
                  onClick={handleDebtorLookup}
                  style={{
                    backgroundColor: '#27AE60',
                    color: '#FFFFFF',
                    border: '2px solid #27AE60',
                    borderRadius: '6px',
                    padding: '10px 16px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    fontFamily: 'Segoe UI, Arial, sans-serif'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1e8449'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#27AE60'}
                >
                  🔍 Search Debtor Filings
                </button>

                <button
                  onClick={handleRegionalAnalysis}
                  style={{
                    backgroundColor: '#27AE60',
                    color: '#FFFFFF',
                    border: '2px solid #27AE60',
                    borderRadius: '6px',
                    padding: '10px 16px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    fontFamily: 'Segoe UI, Arial, sans-serif'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1e8449'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#27AE60'}
                >
                  🗺️ Regional Analysis
                </button>

                {/* Row 2 */}
                <button
                  onClick={handleTopDebtors}
                  style={{
                    backgroundColor: '#27AE60',
                    color: '#FFFFFF',
                    border: '2px solid #27AE60',
                    borderRadius: '6px',
                    padding: '10px 16px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    fontFamily: 'Segoe UI, Arial, sans-serif'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1e8449'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#27AE60'}
                >
                  🏆 Top Debtors
                </button>

                <button
                  onClick={handleSecuredParties}
                  style={{
                    backgroundColor: '#27AE60',
                    color: '#FFFFFF',
                    border: '2px solid #27AE60',
                    borderRadius: '6px',
                    padding: '10px 16px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    fontFamily: 'Segoe UI, Arial, sans-serif'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1e8449'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#27AE60'}
                >
                  🏦 Lender Analysis
                </button>
              </div>

              {/* Full Width Button */}
              <button
                onClick={handleAmendmentTrends}
                style={{
                  backgroundColor: '#27AE60',
                  color: '#FFFFFF',
                  border: '2px solid #27AE60',
                  borderRadius: '6px',
                  padding: '10px 16px',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  fontFamily: 'Segoe UI, Arial, sans-serif',
                  width: '100%'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#1e8449'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#27AE60'}
              >
                📊 Amendment Trends
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
